/** For a sign-in page, the page it returns to, so the login page never lands in its own `redirectTo`. */
export function pageToReturnToAfterSignIn(pathAndSearch: string): string {
    let page = pathAndSearch;
    try {
        let url = new URL(page, window.location.origin);
        // A page nested more than once by an earlier redirect unwraps to the innermost one.
        while (url.pathname.startsWith('/auth/')) {
            // Without a `redirectTo`, the login form would send the user back to itself.
            page = url.searchParams.get('redirectTo') ?? '/';
            url = new URL(page, window.location.origin);
        }
        return page;
    } catch {
        // A `redirectTo` that isn't a URL, such as `//`. None of the app's redirects write one.
        return '/';
    }
}
